import Api from "../config/Axios";

const authConfig = (token, user_id) => ({
  headers: {
    Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
    UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
  },
});

export const getCmsPages = (token, user_id) => {
  return Api.get("api/web/cms/pages", authConfig(token, user_id));
};

export const getCmsActive = (token, user_id, pageKey) => {
  return Api.get(`api/web/cms/pages/${pageKey}/active`, authConfig(token, user_id));
};

export const getCmsVersions = (token, user_id, pageKey) => {
  return Api.get(`api/web/cms/pages/${pageKey}/versions`, authConfig(token, user_id));
};

export const saveCmsNewVersion = (token, user_id, pageKey, payload) => {
  return Api.post(`api/web/cms/pages/${pageKey}/versions`, payload, authConfig(token, user_id));
};

export const sendCmsToRider = (token, user_id, pageKey) => {
  return Api.post(`api/web/cms/pages/${pageKey}/send-to-rider`, {}, authConfig(token, user_id));
};

